<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="board-list">
				<h3>1:1문의</h3>
				<p class="text-center" style="margin-bottom: 50px;">
					같은 문의를  여러채널로 하실경우 1개 채널에서만 답변이 가능합니다<br>
					중복된 다른채널의 문의는 답변완료로 처리됩니다 이점 양해 바랍니다.
				</p>
				<el-row style="padding: 0 auto; margin:0 auto; ">
					<el-col :xs="24" :sm="8">
						<el-select v-model="cate_value" @change="categoryChange" class="category"  placeholder="카테고리">
						    <el-option 
						      v-for="item in category"
						      :key="item.id"
						      :label="item.cate_name"
						      :value="item.id">
						    </el-option>
						</el-select>
					</el-col>
					<el-col :xs="24" :sm="16">
						<el-row style="margin-left: 20px;">
							<el-col :span="16"><el-input v-model="search" placeholder=""></el-input></el-col>
							<el-col :offset="1" :span="7"><el-button type="primary" @click="onSearch">검색 <i class="el-icon-search"></i></el-button></el-col>
						</el-row>
					</el-col>
				</el-row>
				
				<div class="list-top">
					<h4>
						전체
						<span>{{total}} 개</span>
					</h4>
				</div>
				<el-table v-if="!isMobile"
				    :data="tableData"
				    stripe empty-text="데이타가 없습니다."
				    style="width: 100%">
				    <el-table-column
				      prop="id"
				      label="번호"
				      width="60">
				    </el-table-column>
				    <el-table-column
				      
				      label="분류"
				      width="200">
						<template slot-scope="scope">
							[{{ scope.row.cate_name }}]		           
						</template>
				    </el-table-column>
				    <el-table-column		     
				      label="제목">
							<template slot-scope="scope">	     
								<i class="el-icon-s-promotion"></i> 
					            <span style="cursor:pointer;" @click="clickDetails(scope.row.id)"> {{ scope.row.title }}</span>				           
					        </template>
				    </el-table-column>
					<el-table-column
					  label="상태"
					  width="180">
					  <template slot-scope="scope">
						 <el-tag v-if="scope.row.status ==1">문의 중</el-tag>
						 <el-tag type="success" v-else-if="scope.row.status ==2">답변완료</el-tag>
					  </template>
					</el-table-column>
					<el-table-column
					  prop="nickname"
					  label="이름"
					  width="180">
					</el-table-column>
					<el-table-column
					  prop="createtime"
					  label="등록일"
					  width="150">
					</el-table-column>
				</el-table>
				<el-table v-else
				  :data="tableData" 
				  stripe 
				  style="padding: 0 10px;">		
					<el-table-column
					  label="제목">
					  <template slot-scope="scope">
					      <i class="el-icon-s-promotion"></i>
					      <span style="cursor:pointer;" @click="clickDetails(scope.row.id)"> {{ scope.row.title }}</span>				           			           
					  </template>
					</el-table-column>
					<el-table-column
					  label="상태"
					  width="110">
					  <template slot-scope="scope">
						 <el-tag v-if="scope.row.status ==1">문의 중</el-tag>
						 <el-tag type="success" v-else-if="scope.row.status ==2">답변완료</el-tag>
					  </template>
					</el-table-column>
				</el-table>
				
				
				<div class="list-bottom">
					<el-button type="primary" round @click="onNav('/addOneConsult')" >문의하기</el-button>			
				</div>
				  
				<div class="page">
					<el-pagination
						layout="prev, pager, next" :page-size="20"
						:total="total"  @current-change="handleCurrentChange">
					</el-pagination>
				</div>
				
				
			</div>	
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request'
	export default {
		components: {
			SupportBanner,
		},
		data() {
			return{
				total:0,
				page:1,
				search: '',
				tableData: [],
				loading: true,
				category: [],
				cate_value: '',
			}
		},
		computed: {
			isMobile() {
			  return window.innerWidth <= 768;
			}
		},
		created() {
			this.getCateName()
			this.getList()
		},
		methods: {
			onSearch(){
				console.log(this.cate_value,"搜索1")	
				console.log(this.search,"搜索2")
				this.getList()
				
			},
			categoryChange(item){
				console.log(item)
				
			},
			clickDetails(id){
				console.log(id,"点击单元格")
				this.$router.push(`/oneConsultDetails/${id}`)
			},
			onNav(url){
				this.$router.push(url)
			},
			getList(){
				this.loading = true
				request.post('/Consult/getOneConsult',
					{
						search:this.search,
						page:this.page,
						cate_id:this.cate_value
					}
				).then(res => {
					this.loading = false
					console.log(res,"列表")
					if(res.code ==1){
						this.total = res.data.total
						this.tableData= res.data.data//this.tableData.concat(res.data.data)
						
					}
						
				}).catch(() => {
					this.loading = false
				});
				
			},
			getCateName(){
				request.post('/Consult/getCateName',{}
				).then(res => {
					if(res.code ==1){
						this.category= res.data
					}
						
				});
			},
			handleCurrentChange(val) {
			    console.log(`当前页: ${val}`);
				this.page = val
				this.getList()
			},
			
			
		}
	}
</script>

<style scoped>
	.board-list h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0 0 50px;
	}
	.category{
		margin: 0 20px 0 140px;
	}
	.list-top{
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 30px;
		margin-bottom: 40px;
	}
	.list-top h4 {
	    font-size: 30px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 0;
	    margin: 0;
	}
	.list-top h4 span {
	    color: var(--main-color);
	}
	.list-bottom{
		display: flex;
		justify-content: end;
		padding-top:20px;
	}
	.page{
		padding-top: 20px;
		text-align: center;
	}
	
	
	
	.text-center {
	    text-align: center !important;
	}
	::v-deep .el-table__header th {
		color: #333; 
	}
	/* 分页背景 */
	::v-deep .el-pager li {
		background-color: #121212;
	}
	::v-deep .el-pagination button:disabled {
		background-color: #121212;
	}
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
	@media (max-width: 768px) {
		.board-list{
			padding: 10px;
		}
		.category{
			width: 94%;
			margin: 0 10px 10px;
		}
		.list-top h4 {
			font-size: 24px;
			padding: 0 10px;
		}
		
		
	}
</style>